import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { spamFixture, a11yFixture, scanFixture, searchFixture } from './fixture';

/**
 * #282 Operator-Sicht für zuvor Orbit-lose Produkt-APIs. Read-only Overviews über
 * das orbit-backend-BFF (/v1/{spam,a11y,scan,search}/overview). Das BFF reicht das
 * Upstream-JSON weitgehend roh durch → im Frontend defensiv/generisch rendern.
 */
function makeOverviewHook(key, path, fixture) {
  return function useOverview() {
    const { fetch } = useApiClient();
    const fixturesMode = useFixturesMode();
    return useQuery({
      queryKey: [key, fixturesMode ? 'fixture' : 'live'],
      queryFn: async () => {
        if (fixturesMode) { await fixtureDelay(); return fixture(); }
        return fetch(path);
      },
      staleTime: 30_000,
    });
  };
}

export const useSpamOverview = makeOverviewHook('product-spam-overview', '/v1/spam/overview', spamFixture);
export const useA11yOverview = makeOverviewHook('product-a11y-overview', '/v1/a11y/overview', a11yFixture);
export const useScanOverview = makeOverviewHook('product-scan-overview', '/v1/scan/overview', scanFixture);
export const useSearchOverview = makeOverviewHook('product-search-overview', '/v1/search/overview', searchFixture);
